export default "__VITE_ASSET__CpBhxBbE__"